import React from 'react';

const TypingIndicator = ({ typingUsers }) => {
  const typingUserCount = Object.keys(typingUsers).length;
  
  if (typingUserCount === 0) return null;

  const firstUser = Object.values(typingUsers)[0];

  return (
    <div className="typing-indicator" key="typing-indicator">
      <div className="typing-row">
        <div className="typing-avatar">
          {firstUser.photoURL ? (
            <img 
              src={firstUser.photoURL} 
              alt="Avatar" 
              className="avatar-img"
              referrerPolicy="no-referrer"
            />
          ) : (
            <div className="avatar-placeholder-msg">
              {firstUser.displayName.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
        
        <div className="typing-content">
          <div className="typing-bubble">
            <div className="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;